import axios from 'axios'
import { config } from "../Config/config"

const spesialisService = {
    getAll: () => {
        const result = axios.get(config.apiUrl + '/spesialis')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    getAllUser: () => {
        const result = axios.get(config.apiUrl + '/user')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    getAllBiodata: () => {
        const result = axios.get(config.apiUrl + '/biodata')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    getAllData: (filter) => {
        const result = axios.post(config.apiUrl + '/spesialisData', filter)
            //ketika berhasil 
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            //untuk pesan errornya
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getFilter: (filter) => {
        const result = axios.post(config.apiUrl + '/spesialisFilter', filter)
            //ketika berhasil 
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            //untuk pesan errornya
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    addData:(data) => {
        const result = axios.post(config.apiUrl + '/spesialis', data)
        .then(respon=> {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    EditData :(data) => {
        const result = axios.put(config.apiUrl + '/spesialis', data)
        .then(respon=> {
            return{
                success : respon.data.success,
                //untuk mengeluarkan isi yang ada di dalam array
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    EditDDelete :(data) => {
        const result = axios.put(config.apiUrl + '/spesialisDelete', data)
        .then(respon=> {
            return{
                success : respon.data.success,
                //untuk mengeluarkan isi yang ada di dalam array
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    getById :(id) => {
        const result = axios.get(config.apiUrl + '/spesialisById/' + id)
        .then(respon=> {
            return{
                success : respon.data.success,
                //untuk mengeluarkan isi yang ada di dalam array
                result : respon.data.result[0]
            }
        })
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    countData: () => {
        const result = axios.get(config.apiUrl + '/count' )
            .then(respon => {
                return {
                    success: respon.data.success,
                    //untuk mengeluarkan isi yang ada di dalam array
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }

}

export default spesialisService